export default {
    functional: true,

    render(h, { data, slots })
    {
        return h(
            'h3',

            {
                staticClass: data.staticClass,

                class: 'vh-modal-title',
            },

            slots().default
        );
    },
};



// WEBPACK FOOTER //
// ./src/components/modal/vh-modal-title.js